export enum Roles {
  GLOBALADMIN = 'GLOBALADMIN',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  SALESPERSON = 'SALESPERSON',
}
